import React from "react";
import { useTranslation } from "react-i18next";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch
} from "react-router";
import { GoBackButton, ShowView, withBreadCrumbs } from "lego-gui-lib";
import { TabContent, TabData } from "../san/tabs/TabContent";
import { TabHeader } from "../san/tabs/TabHeader";
import {
  CreateHuntingGroupMember,
  IndexHuntingGroupMember,
  ShowHuntingGroupMember
} from "./huntingGroupMember/views";
import { TitleRow } from "lego-gui-lib/lib/components/Views/TitleRow";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { HuntingGroupSchemaForm } from "./schema";

export const HuntingGroupShowView = () => {
  const i18n = useTranslation();
  const match = useRouteMatch();
  const title = i18n.t("hns:huntingGroup:domain");
  const t = i18n.t.bind(i18n);
  const baseUrl = match.url;
  const history = useHistory();
  const location = useLocation();

  const tabs: TabData[] = [
    {
      label: t("common:general"),
      path: "/general",
      Element: <FormView />
    },
    {
      label: t("hns:huntingGroupMember:members"),
      path: "/members",
      Element: <HuntingGroupMemberViewComponent />
    }
  ];

  return withBreadCrumbs(
    { to: match.url, children: title },
    <>
      <Route
        exact={true}
        path={baseUrl + "/:type"}
        render={() => {
          return (
            <>
              <TitleRow
                classes={{ titleText: "", title: "" }}
                prefix={<GoBackButton goBack={() => history.goBack()} />}
                title={title}
              />
              <TabHeader
                baseUrl={baseUrl}
                tabs={tabs}
                value={location.pathname}
              />
            </>
          );
        }}
      />

      <TabContent baseUrl={baseUrl} tabs={tabs} />
    </>
  );
};

const injectDataSource = (comp: any) =>
  inject("huntingGroup", "i18n", "SAN", "router")(observer(comp));

export const FormView = injectDataSource(({ id, huntingGroup, SAN }: any) => {
  const history = useHistory();

  return (
    <ShowView
      preloadData={false}
      dataSource={huntingGroup.oneDataSource}
      prefix={
        <GoBackButton
          goBack={() => {
            history.goBack();
          }}
        />
      }
      titleRow={false}
      fields={HuntingGroupSchemaForm(SAN)}
      id={id}
    />
  );
});

const HuntingGroupMemberViewComponent = () => {
  const match = useRouteMatch();
  const basePath = match.path;

  return (
    <>
      <Switch>
        <Route
          exact={true}
          path={basePath}
          component={IndexHuntingGroupMember}
        />
        <Route
          path={basePath + "/create/:memberId"}
          component={CreateHuntingGroupMember}
        />
        <Route
          path={basePath + "/create"}
          component={CreateHuntingGroupMember}
        />
        <Route
          path={basePath + "/:memberId"}
          component={ShowHuntingGroupMember}
        />
      </Switch>
    </>
  );
};
